module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-382.aa9932b.woff2";